import { Injectable } from '@angular/core';
import { AgregationService } from '@ispm-client/modules/aggregator/services';
import { Subject } from 'rxjs/Rx';
import {IdataBinding} from "@ispm-client/modules/aggregator/interfaces";
import {take} from "rxjs/operators";
import { Observable } from 'rxjs';
import { isEmpty } from 'lodash';
import {FormHandlerService} from "@ispm/dynamic-form/services/form-handler.service";
import {Store} from "@ngrx/store";
import {IgenomicsState} from "@ispm/core/interfaces/genomics-state.interface";

@Injectable()
export class DataNotificationService {

  private subject = new Subject<any>();
  private emitChangeSource = new Subject<any>();
  changeEmitted$ = this.emitChangeSource.asObservable();

  constructor(private _agregatorService: AgregationService,
              private _formHandlerService: FormHandlerService,
              private store: Store<IgenomicsState>) {
  }

  saveCarePlan() {
    this.emitChangeSource.next("");
  }

  confirmNextButton(status) {
    this.emitChangeSource.next(status);
  }

  showDataAvailability(dataBindings, identifier): Observable<any> {
    return this._agregatorService.registerQuery(dataBindings, identifier).map(data => {
      return data[0];
    });
  }

  showDataNotification(formId): Observable<any> {
    let wrapperIdentifier = null;
    this._formHandlerService.getForm(formId).take(1).publish().connect();
    return this.getFormDataBindings(formId)
      .filter(dataBindings => !isEmpty(dataBindings))
      .pipe(take(1))
      .switchMap((dataBindings)=>{
        wrapperIdentifier = dataBindings[0].identifier;
        return this.showDataAvailability(dataBindings, formId);
      });
  }

  public getFormDataBindings(formId: string): Observable<IdataBinding[]> {
    return this.store.select('forms', 'dataBindings').map(forms => forms.get(formId));
  }

  sendFormId(message: string) {
    this.subject.next(message);
  }

  getFormId(): Observable<any> {
    return this.subject.asObservable();
  }

}
